import React from 'react';
import { Typography } from '@doveit/lego';
import { BasicSectionProps } from '../types';
import PageSection from '../../components/page-section/PageSection';
import Markdown from '../../components/markdown/Markdown';
import CityList, { CityListProps } from '../../components/city-list/CityList';
import ArticleMarkdown from '../../components/article-markdown/ArticleMarkdown';

export interface AgenciesSectionProps extends BasicSectionProps {
  agencies: CityListProps['cities'],
}

export const AgenciesSection: React.FC<AgenciesSectionProps> = ({
  title,
  content,
  agencies,
}) => (
  <PageSection>
    <PageSection.Wrapper>
      {title && (
        <PageSection.Title>
          <Markdown>
            {title.trim()}
          </Markdown>
        </PageSection.Title>
      )}
      {content && (
        <PageSection.Block noSpacing={!title && !content}>
          <Typography.BODY>
            <ArticleMarkdown>
              {content.trim()}
            </ArticleMarkdown>
          </Typography.BODY>
        </PageSection.Block>
      )}
      <PageSection.Block>
        <CityList cities={agencies} />
      </PageSection.Block>
    </PageSection.Wrapper>
  </PageSection>
);

export default AgenciesSection;
